
import { defineComponent } from 'vue'
import { createValidations } from '@/helpers/commons/validationHelper'
import Card from 'primevue/card'
import useValidate from '@vuelidate/core'
import tabViewDescriptor from '../TenantManagementTabViewDescriptor.json'
import KnValidationMessages from '@/components/UI/KnValidatonMessages.vue'
import tenantDetailValidationDescriptor from './TenantDetailValidationDescriptor.json'
import { iTenant } from '../../TenantManagement'
import { AxiosResponse } from 'axios'

export default defineComponent({
    name: 'detail-tab',
    components: {
        Card,
        KnValidationMessages
    },
    props: {
        selectedTenant: {
            type: Object,
            required: false
        },
        listOfThemes: Array
    },
    emits: ['fieldChanged', 'roleTypeChanged'],
    data() {
        return {
            tabViewDescriptor,
            tenantDetailValidationDescriptor,
            v$: useValidate() as any,
            tenant: {} as iTenant,
            themes: [] as any
        }
    },
    computed: {
        disableField() {
            if (this.tenant.TENANT_ID) return true
            return false
        }
    },
    validations() {
        return {
            tenant: createValidations('tenant', tenantDetailValidationDescriptor.validations.tenant)
        }
    },
    watch: {
        async selectedTenant() {
            this.v$.$reset()
            this.tenant = { ...this.selectedTenant } as iTenant
            await this.$http.get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `multitenant/${this.tenant.TENANT_NAME}/logo`).then((response: AxiosResponse<any>) => {
                this.tenant.TENANT_IMAGE = response.data
            })
            await this.$http.get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `multitenant/${this.tenant.TENANT_NAME}/logo-wide`).then((response: AxiosResponse<any>) => {
                this.tenant.TENANT_IMAGE_WIDE = response.data
            })
        },
        listOfThemes() {
            this.themes = [...(this.listOfThemes as any[])]
        }
    },
    created() {
        if (this.selectedTenant && Object.keys(this.selectedTenant).length > 0) {
            this.tenant = { ...this.selectedTenant } as iTenant
        } else {
            this.tenant = {} as iTenant
            this.tenant.TENANT_THEME = 'sbi_default'
        }
        if (this.listOfThemes) this.themes = [...this.listOfThemes] as any
    },
    methods: {
        onFieldChange(fieldName: string, value: any) {
            this.$emit('fieldChanged', { fieldName, value })
        },
        uploadFile(event): void {
            const reader = new FileReader()
            reader.addEventListener(
                'load',
                () => {
                    this.tenant.TENANT_IMAGE = reader.result || ''
                    this.onFieldChange('TENANT_IMAGE', this.tenant.TENANT_IMAGE)
                },
                false
            )
            if (event.srcElement.files[0] && event.srcElement.files[0].size < process.env.VUE_APP_MAX_UPLOAD_IMAGE_SIZE) {
                reader.readAsDataURL(event.srcElement.files[0])
                this.v$.$touch()
            } else this.$store.commit('setError', { title: this.$t('common.error.uploading'), msg: this.$t('common.error.exceededSize', { size: '(200KB)' }) })
        },

        uploadExtendedFile(event): void {
            const reader = new FileReader()
            reader.addEventListener(
                'load',
                () => {
                    this.tenant.TENANT_IMAGE_WIDE = reader.result || ''
                    this.onFieldChange('TENANT_IMAGE', this.tenant.TENANT_IMAGE_WIDE)
                },
                false
            )
            if (event.srcElement.files[0] && event.srcElement.files[0].size < process.env.VUE_APP_MAX_UPLOAD_IMAGE_SIZE) {
                reader.readAsDataURL(event.srcElement.files[0])
                this.v$.$touch()
            } else this.$store.commit('setError', { title: this.$t('common.error.uploading'), msg: this.$t('common.error.exceededSize', { size: '(200KB)' }) })
        }
    }
})
